import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  selectPagination,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';

import PropTypes from 'prop-types';

import NotificationsDrop from './NotificationsDrop';

const eventsNotReadUserNoticesListRN =
  'eventsModule.lists.eventsNotReadUserNoticesList';

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropDown: false
    };
    this.props.sendRequest();
  }

  render() {
    let badgeCountNotReadNoticesNotices;
    if (this.props.pagination.totalCount > 0) {
      badgeCountNotReadNoticesNotices = (
        <span className="badge badge-xs badge-circle badge-info badge-counter">
          {this.props.pagination.totalCount}
        </span>
      );
    }

    return (
      <li className={`dropdown ${this.state.showDropDown ? 'open' : ''}`}>
        <a
          href=""
          onClick={e => {
            e.preventDefault();
            this.setState({ showDropDown: !this.state.showDropDown });
          }}
        >
          {badgeCountNotReadNoticesNotices}
          <i className="fa fa-lg fa-bell" />
        </a>
        {this.state.showDropDown ? (
          <NotificationsDrop
            closeDropdown={() => this.setState({ showDropDown: false })}
          />
        ) : null}
      </li>
    );
  }
}

Notifications.propTypes = {
  sendRequest: PropTypes.func.isRequired,
  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  pagination: selectPagination(state, eventsNotReadUserNoticesListRN)
});

const mapDispatchToProps = dispatch => ({
  sendRequest: () => dispatch(sendRequest(eventsNotReadUserNoticesListRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifications);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Header/Notifications/index.js